module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"safeZone":"Ambiente Seguro","mundipagg":"Mundipagg","pagarme":"Pagar.me"},"en-US":{"safeZone":"Secure environment","mundipagg":"Mundipagg","pagarme":"Pagar.me"}}')
  delete Component.options._Ctor
}
